import { AttributeUtils } from "../../../../coding/utils/attribute-utils";

export const generateOptions = (
  options: string[],
): { label: string; value: any }[] =>
  options.map((type) => ({
    label: AttributeUtils.getOptionLabel(type),
    value: type,
  }));

export const booleanOptions = [
  { value: false, label: "Not present" },
  { value: true, label: "Present" },
];

export type SelectOption = { label: string; value: any };
